// extracted by mini-css-extract-plugin
export var errorPage = "error-page_q1BUvBogrLuaqOxayY_r";
export var errorPageSmallError = "error-page-small-error_Hc1tboUlQcOqIF9A0lGX";
export var errorPageSubtitle = "error-page-subtitle_J51dz3l0cgk9huFD7345";
export var errorPageTitle = "error-page-title_w42lc5LOMIihrz8J9LAw";